import { useQuery } from "react-query";
import { useXeroClient } from "./useXeroClient";
import { useOrganisationContext } from "./useOrganisationContext";

export function useNonReportedTotals({ enabled = true } = {}) {
    const xero = useXeroClient();
    const { selectedOrganisation } = useOrganisationContext();
    const contactIds = selectedOrganisation.pos_contacts_ids?.split(',') || []
    let pos_filter = ''
    if (selectedOrganisation.pos_contacts_ids) {
        const filterStrings = contactIds.map(contactId => `Contact.ContactID!=GUID("${contactId}")`);
        pos_filter = ` AND (` + filterStrings.join(" AND ") + ')'
    }

    return useQuery({
        queryKey: ["non-reported-totals", selectedOrganisation?.id],
        queryFn: async () => {
            const [reported_invoices, total_invoices, non_reported_creditNotes] = await Promise.all([
                xero.get("invoices", {
                    params: {
                        raw: `TYPE="ACCREC" AND Date >= DateTime(${selectedOrganisation.onboarding_date}) ${pos_filter}`,
                        pageSize: 5,
                        page: 1,
                        as_json: true,
                        extra_params: {
                            Statuses: "AUTHORISED,PAID",
                            SearchTerm:"(zatca-reported)"
                        },
                    }
                }).get("data"),
                xero.get("invoices", {
                    params: {
                        raw: `TYPE="ACCREC" AND Date >= DateTime(${selectedOrganisation.onboarding_date}) ${pos_filter}`,
                        pageSize: 5,
                        page: 1,
                        as_json: true,
                        extra_params: {
                            Statuses: "AUTHORISED,PAID",
                        },
                    }
                }).get("data"),
                xero.get("creditnotes", {
                    params: {
                        raw: `TYPE="ACCRECCREDIT" AND (Status = "AUTHORISED" OR Status = "PAID") AND Date >= DateTime(${selectedOrganisation.onboarding_date}) ${pos_filter}`,
                        pageSize: 5,
                        page: 1,
                        as_json: true,
                        extra_params: {
                            Statuses: "AUTHORISED,PAID",
                            SearchTerm:"(zatca-reported)"
                        },
                    }
                }).get("data"),
            ]);

            const invoices = {
                itemCount: total_invoices.itemCount - reported_invoices.itemCount,
            };
            const creditNotes = {
                itemCount: non_reported_creditNotes.itemCount,
            };

            return { invoices, creditNotes };
        },
        enabled: enabled && !!selectedOrganisation?.onboarding_date,
        staleTime: 5 * 60 * 1000,       // Auto-refetch after 5minutes
        // refetchOnWindowFocus: false,    // Don't refetch on tab focus
        refetchOnMount: false,          // Don't refetch on remount
        useErrorBoundary: false,
    });
}
